import { useEmailTemplate } from '@dealstack/frontend/shared/components/EmailTemplates/hooks/useEmailTemplates';
import type { EmailTemplateScope } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Alert, Box, Button, Group, Skeleton } from '@mantine/core';

import { EmailTemplateEditorForm } from './EmailTemplateEditorForm';

interface Props {
	scope: EmailTemplateScope;
	templateType: string;
	onBack: () => void;
}

export const EmailTemplateDetail = ({ scope, templateType, onBack }: Props) => {
	const tMipManage = useTranslationMipManage();

	const {
		data: detail,
		isLoading,
		isError,
		refetch,
	} = useEmailTemplate({
		scope,
		type: templateType,
	});

	return (
		<Box
			w="100%"
			h="100%"
			pb="lg"
			style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
		>
			{isLoading && <Skeleton height={520} radius="md" />}

			{!isLoading && (isError || !detail) && (
				<Alert color="red" title={tMipManage('email_templates.editor.load_error.title')}>
					<Group gap="sm">
						<Button variant="light" onClick={() => refetch()}>
							{tMipManage('email_templates.common.retry')}
						</Button>
						<Button variant="subtle" onClick={onBack}>
							{tMipManage('email_templates.common.back')}
						</Button>
					</Group>
				</Alert>
			)}

			{!isLoading && detail && (
				<EmailTemplateEditorForm
					key={templateType}
					scope={scope}
					detail={detail}
					onBack={onBack}
				/>
			)}
		</Box>
	);
};
